import { combineReducers } from '@reduxjs/toolkit';
import { ADAPTIVE_SLICE_NAME, adaptiveReducer } from '@/modules/Adaptive';
import { ADMINS_LIST_SLICE_NAME, adminsReducer } from '@/modules/Admins';
import { AUTH_SLICE_NAME, authReducer } from '@/modules/Auth';
import { BIDDING_SLICE_NAME, biddingReducer } from '@/modules/Bidding';
import { DOC_SETTINGS_SLICE_NAME, documentsSettingsReducer } from '@/modules/DocumentsSettings';
import { LOGS_SLICE_NAME, logsReducer } from '@/modules/Logs';
import { ORDERS_SLICE_NAME, ordersReducer } from '@/modules/Order';
import { DOCUMENTS_SLICE_NAME, documentsReducer } from '@/modules/PropertyDocuments';
import { PRICES_SLICE_NAME, pricesReducer } from '@/modules/Prices';
import { PROFILE_SLICE_NAME, profileReducer } from '@/modules/Profile';
import { PROPERTY_PROGRESS_SLICE_NAME, propertyProgressReducer } from '@/modules/PropertyProgress';
import { SETTINGS_SLICE_NAME, settingsReducer } from '@/modules/Settings';
import { UPLOADS_SLICE_NAME, uploadsReducer } from '@/modules/Upload';
import { USERS_LIST_SLICE_NAME, usersReducer } from '@/modules/Users';
import { PROPERTIES_SLICE_NAME, propertiesReducer } from '@/modules/Properties';
import { PICTURES_SLICE_NAME, picturesReducer } from '@/modules/Pictures';

export const rootReducer = combineReducers({
  [AUTH_SLICE_NAME]: authReducer,
  [ADAPTIVE_SLICE_NAME]: adaptiveReducer,
  [ADMINS_LIST_SLICE_NAME]: adminsReducer,
  [BIDDING_SLICE_NAME]: biddingReducer,
  [DOC_SETTINGS_SLICE_NAME]: documentsSettingsReducer,
  [DOCUMENTS_SLICE_NAME]: documentsReducer,
  [LOGS_SLICE_NAME]: logsReducer,
  [PRICES_SLICE_NAME]: pricesReducer,
  [PROFILE_SLICE_NAME]: profileReducer,
  [PROPERTIES_SLICE_NAME]: propertiesReducer,
  [ORDERS_SLICE_NAME]: ordersReducer,
  [SETTINGS_SLICE_NAME]: settingsReducer,
  [UPLOADS_SLICE_NAME]: uploadsReducer,
  [USERS_LIST_SLICE_NAME]: usersReducer,
  [PICTURES_SLICE_NAME]: picturesReducer,
  [PROPERTY_PROGRESS_SLICE_NAME]: propertyProgressReducer,
});
